import React from 'react';
import styled from 'styled-components';

import { IconEnvelop } from './icon';
import { HorizontalLayout } from './Layout';
import { Text, TextProps } from './Text';

type MailToProps = TextProps & {
    address: string | undefined;
};

export const MailTo = ({ address, ...textProps }: MailToProps) => {
    if (!address) {
        return null;
    }

    return (
        <Wrapper>
            <StyledLink href={`mailto:${address}`} onClick={(ev) => ev.stopPropagation()}>
                <HorizontalLayout $rowCenter $gap={4}>
                    <IconEnvelop size="micro" />
                    <Text $truncated {...textProps}>
                        {address}
                    </Text>
                </HorizontalLayout>
            </StyledLink>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    max-width: fit-content;
`;

const StyledLink = styled.a`
    text-decoration: none;
    color: inherit;

    &:hover {
        text-decoration: underline;
    }
`;
